module.exports = __webpack_public_path__ + "static/media/S1N6-4.5b86070d.svg";